export default __webpack_public_path__ + "stuffedCrustNone.8ec4dddb.png";